import React from "react";
import ReactDOM from "react-dom/client";
// Initializes the error tracker
import "~/utils/errorTracker";
import App from "./App";

window.addEventListener("DOMContentLoaded", (_event) => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
